import { render, staticRenderFns } from "./summary-card-export.vue?vue&type=template&id=06ed9d80&scoped=true&"
import script from "./summary-card-export.vue?vue&type=script&lang=js&"
export * from "./summary-card-export.vue?vue&type=script&lang=js&"
import style0 from "./summary-card-export.vue?vue&type=style&index=0&id=06ed9d80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ed9d80",
  null
  
)

export default component.exports